// Hardcoded list of Disney+ campaigns that require Impact VTR tracking pixel
export const DISNEY_PLUS_VTR_TRACKING_CAMPAIGNS = new Set([
	'DISNEY+_SEPTEMBER_PROMO_BURST1_CO_SRA',
	'DISNEY+_SEPTEMBER_PROMO_BURST1_PE_SRA',
	'DISNEY+_SEPTEMBER_PROMO_BURST1_AR_SRA',
	'DISNEYPLUS_DE_SEPTEMBER_PROMO_BURST2_DE_SRA',
	'DISNEY+_SEPTEMBER_PROMO_BURST1_MX_SRA',
	'DISNEY+_SEPTEMBER_PROMO_BURST1_BR_SRA',
	'DISNEYPLUS_UK_SEPTEMBER_PROMO_BURST2_GB_SRA',
	'DISNEYPLUS_SEPTEMBER_PROMO_BURST2_FR_SRA',
	'SEPTEMBER_LAUNCHES_ELIO_BURST3_ES_SRA',
]);

export const disneyPlusVtrScript = `
	(function(i,m,p,a,c,t){
		c.ire_o=p;
		c[p]=c[p]||function(){(c[p].a=c[p].a||[]).push(arguments)};
		t=a.createElement(m);
		var z=a.getElementsByTagName(m)[0];
		t.async=1;
		t.src=i;
		z.parentNode.insertBefore(t,z)
	})('https://utt.impactcdn.com/P-A1206980-cda2-4fe0-a33a-8bfca7f508ee1.js','script','impactStat',document,window);
	impactStat('transformLinks');
	impactStat('trackImpression');
`;
